import { Navigate } from 'react-router-dom';
import { RouteConstants } from '../constants/routes';
import { useHasPermission } from '../hooks';
import useEntitySelectionModal from '../hooks/useEntitySelectionModal';
import UnauthorizedAccessView from '../pages/unauthorized-access';
import { UserStore } from '../store';
import { ProtectedRouteInterface } from './types';

const ProtectedRoute: ProtectedRouteInterface = ({
  moduleId,
  title = '',
  children,
}) => {
  const isLoggedIn = UserStore((state) => state.isLoggedIn);
  const entityCodesList = UserStore((state) => state.entityCodesList);
  const isEntitySelected = UserStore((state) => !!state.entityCode);
  const setEntitycode = UserStore((state) => state.setEntityCode);

  const { hasModulePermission } = useHasPermission();

  const { openEntityModal } = useEntitySelectionModal();

  if (!isLoggedIn || !Array.isArray(entityCodesList)) {
    return <Navigate to={RouteConstants.LOGIN} replace />;
  }

  if (!isEntitySelected && entityCodesList.length > 0) {
    if (entityCodesList.length > 1) {
      openEntityModal({ isSelectionRequired: true });
    } else {
      setEntitycode(entityCodesList[0]);
    }
  }

  if (!hasModulePermission({ moduleId })) {
    return <UnauthorizedAccessView />;
  }

  return <>{children} </>;
};

export default ProtectedRoute;
